/**
 * BRAVON-6291 — front-end mirror of the backend `NeofinCardNormalizer`
 * (api_core_kit/infrastructure/game/market/neofinCardNormalizer.js).
 *
 * The new generation of NeoCards introduced competency domains with a `_NNNN`
 * generation suffix (e.g. `START_0626`, `IC_0626`) that must coexist with the
 * legacy names (`Start`, `INNER CIRCLE`, ...). This helper recognizes both and
 * normalizes them to a single canonical (clean legacy) name so the report
 * filters keep working — and stay free of duplicate options — for old + new.
 *
 * Keep in sync with the backend module if the alias table ever changes.
 */

// Generation suffix appended to new-generation names (matches any 4-digit tag,
// so a future `_0726` needs no code change).
const GENERATION_SUFFIX = /_\d{4}$/;

// Lookup key = name, trimmed + upper-cased + suffix-stripped -> canonical name.
const COMPETENCY_ALIASES = {
  'START LV': 'Start LV',
  LITE: 'Start LV',
  START: 'Start',
  PREMIUM: 'Premium',
  ELITE: 'Elite',
  VIP: 'VIP',
  'INNER CIRCLE': 'INNER CIRCLE',
  IC: 'INNER CIRCLE',
};

// Display order (lower = shown first).
const COMPETENCY_ORDER = {
  'Start LV': 0,
  Start: 1,
  Premium: 2,
  Elite: 3,
  VIP: 4,
  'INNER CIRCLE': 5,
};

export const normalizeCompetencyName = raw => {
  if (!raw) return null;
  const key = String(raw).trim().toUpperCase().replace(GENERATION_SUFFIX, '');
  return COMPETENCY_ALIASES[key] || null;
};

export const isNeoCardCompetency = raw => normalizeCompetencyName(raw) !== null;

export const competencyOrder = raw => {
  const canonical = normalizeCompetencyName(raw);
  return canonical && canonical in COMPETENCY_ORDER
    ? COMPETENCY_ORDER[canonical]
    : Number.MAX_SAFE_INTEGER;
};
